import { ToastConfigs, ToastGlobalConfig } from '@northfork/ng-basics'

/**
 * maxOpened is useless without autoDismiss.
 * It seems that the toasts get created asynchronously, so if the toasts get triggered
 * in rapid succession it is possible to exceed the limit.
 */
ToastGlobalConfig.maxOpened = 3
ToastGlobalConfig.autoDismiss = true

/**
 * By default, preventDuplicates only checks the content of the toast not the title.
 * You can make it also compare titles by enabling includeTitleDuplicates.
 */
ToastGlobalConfig.preventDuplicates = true

ToastGlobalConfig.positionClass = 'toast-bottom-right'
ToastConfigs.error.disableTimeOut = false
